import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import * as yup from "yup";
import { Box, Button, CssBaseline } from "@mui/material";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";

import { getTokenRefresh } from "../../../../helpers/token/refreshToken";

import { getVehicle } from "../../../../api/users/driver/vehicle";
//sidebar
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme as themeStyles } from "@mui/material/styles";
import Topbar from "../../../../components/topbar/TopBar";
import Header from "../../../../components/header/Header";
import VehicleRenovateForm from "./components/VehicleRenovateForm";
import Sidebar from "../../../../components/sidebar/Sidebar";

const VehicleRenovate = () => {
  const themeSidebar = themeStyles();
  const matchesSM = useMediaQuery(themeSidebar.breakpoints.down("sm"));
  const [vehicle, setVehicle] = useState(null);
  const [isUpdate, setIsUpdate] = useState(true);

  const { id } = useParams();

  useEffect(() => {
    vehicleComplete();
  }, []);

  const vehicleComplete = async () => {
    try {
      const token = getTokenRefresh();
      const response = await getVehicle(token, id);
      console.log(response);
      setVehicle(response?.data[0]);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <CssBaseline />
      <div className="app">
        {!matchesSM && <Sidebar />}
        <main className="content">
          <Topbar />
          <Box m="10px">
            {/* HEADER */}
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Header title="VEHICULO" subtitle="" />

              <Button
                color="secondary"
                onClick={(e) => {
                  setIsUpdate(!isUpdate);
                }}
              >
                <CreateOutlinedIcon />
                EDITAR VEHICULO
              </Button>
            </Box>
            {vehicle ? (
              <VehicleRenovateForm
                vehicle={vehicle}
                operation={true}
                isUpdate={isUpdate}
              />
            ) : (
              <div>loading...</div>
            )}
          </Box>
        </main>
      </div>
    </>
  );
};

export default VehicleRenovate;
